// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__NQBd9","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2pU9W"};